export * from './page-forgot-password.component';
